import React, { useState, useEffect } from "react";
import { Link } from "gatsby"
import Select from 'react-select';
import { useQuery} from '@apollo/client';
import gql from "graphql-tag"
import { Container, Row, Col } from 'react-bootstrap'
import "../LocationBlock/LocationBlock.scss";
import "./Brands.scss";
import BoxBlock from "../BoxBlock/BrandsBox"

const Brands = ({Module}) => {
    const[brands_list, setBrandsList] = useState([]);

    const BrandsQuery = gql(`
        query BrandsQuery{
            brands(sort:"sort:asc"){
                id
                slug
                title
                tile_image{
                  alternativeText
                  url
                }
                imagetransforms
            }
        }
    `)

    const{loading, error, data} = useQuery(BrandsQuery);

    useEffect(() => {
        data?.brands?.length > 0 && setBrandsList(data?.brands);
    }, [data])


    return (
        <React.Fragment>
            <section className="location-block brands_list">
                <Container>
                    <Row>
                        <Col>
                            {Module?.title && <h2>{Module?.title}</h2>}

                            {brands_list?.length > 0 && 
                            <div className="box-wrap">
                                {brands_list.map((item, index) => (
                                    <BoxBlock key={index} BoxList={item} />
                                ))}
                            </div>
                            }
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default Brands;
